<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-text>
      <v-container>
        <v-row>
          <v-col align="right">
            <TextButton @click="openRegistrarNuevaRemesa"> REGISTRAR REMESA </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="ui-module-card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="remesas" class="transparent" calculate-widths>
                  <template v-slot:[`item.fk_idLoc`]="{ item }">
                    {{ getNoLicencia(item.fk_idLoc) }}
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              variant="secondary"
                              icon="mdi-pencil"
                              :loading="loadingEditarRemesa === item.idRemesa"
                              @click="openEditarRemesa(item)"
                            />
                          </span>
                        </template>
                        <span>Editar Remesa</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import TextButton from '@/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      loading: false,
      loadingEditarRemesa: false,
      DIALOG_TYPES,
      selectedRemesa: null,
      headers: [
        { text: 'ID Loc', value: 'fk_idLoc' },
        { text: 'Fecha de Alta', value: 'fechaAlta' },
        { text: 'Fecha de Trámite', value: 'fechaTramite' },
        { text: 'Número de Oficio', value: 'numOficio' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
    }
  },

  computed: {
    ...mapGetters('remesas', {
      remesas: 'getRemesas',
    }),
    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('remesas', {
      fetchRemesas: 'fetchRemesas',
    }),
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    getNoLicencia(idLoc) {
      const loc = this.locs.find((l) => l.idLoc === idLoc)
      return loc?.noLicencia || '-'
    },
    openRegistrarNuevaRemesa() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_REMESA)
    },
    async openEditarRemesa(remesa) {
      this.loadingEditarRemesa = remesa.idRemesa
      await this.fetchLocs()
      this.loadingEditarRemesa = false
      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_REMESA,
        props: { remesaSeleccionada: remesa },
      })
    },
  },

  created() {
    this.fetchRemesas()
    this.fetchLocs()
  },
}
</script>

<style scoped>
/* Estilos modernos para RemesasTabContent */
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 48px rgba(108, 92, 231, 0.3);
  border-color: rgba(108, 92, 231, 0.4);
}

/* Título */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.2s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.12) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.08) !important;
  padding: 14px 16px !important;
  font-size: 0.9375rem;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
  transform: scale(1.1);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #e0e0e0 !important;
}

/* Loading state */
::v-deep .v-progress-linear {
  border-radius: 8px;
}

::v-deep .v-progress-linear__background {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-progress-linear__determinate {
  background: linear-gradient(90deg, #6c5ce7 0%, #a29bfe 100%) !important;
  box-shadow: 0 0 12px rgba(108, 92, 231, 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
